"use client";
import {Card, CardContent} from "@/components/ui/card";
import {Button} from "@/components/ui/button";
import {FaClock, FaUser} from "react-icons/fa";
import {FaLocationDot} from "react-icons/fa6";
import Link from "next/link";
import {reworkDate} from "@/lib/helpers/reworkDate";
import ParticipantModal from "@/components/Participant/ParticipantModal";
import {useState} from "react";

export default function OpenTrainingCard({id,title, short_description, date, address, place_max, participants_count,image,slug, price,mapsUrl,participants, userId, firstname, lastname}){
    const [participantOpen, setParticipantOpen] = useState(false);
    return(
        <>
            <Card className={"border-primary"}>
                <CardContent className={"p-0 m-0"}>
                    <div className={"rounded-t-xl relative"}>
                        <Link href={"/events/" + slug}>
                            <img src={image} className={"object-cover rounded-t-xl min-w-full h-60"}/>
                        </Link>
                        <div className={"absolute bottom-2 w-full"}>
                            <div className={"flex justify-end m-2"}>
                                <div className={"bg-primary py-1 px-3 rounded font-semibold text-white text-sm"}>{price ? `${price}€` : "Gratuit"}</div>
                            </div>
                        </div>
                    </div>

                    <div className={"grid gap-y-2 px-3"}>
                        <h4 className={"font-bold"}>{title} du {reworkDate(date,false,'fr')}</h4>
                        <p>{short_description}</p>
                        <p className={"flex gap-x-1 items-center text-[#E6A900]"}>
                            <FaClock/>
                            {reworkDate(date,false,'fr',true)}
                        </p>
                        {mapsUrl
                            ?
                            <Link href={mapsUrl} target={"_blank"}>
                                <button className={"flex gap-x-1 items-center text-[#E6A900] underline"}>
                                    <FaLocationDot/>
                                    {address}
                                </button>
                            </Link>
                            :
                            <p className={"flex gap-x-1 items-center text-[#E6A900]"}>
                                <FaLocationDot/>
                                {address}
                            </p>

                        }
                        <button className={"flex gap-x-1 items-center text-[#E6A900]"} onClick={() => setParticipantOpen(true)}>
                            <FaUser/>
                            {participants_count}/{place_max}
                        </button>
                        {firstname ?
                            <Link href={`/profile/${userId}`}>
                                <p>Animé par : <span className={"text-primary"}>{firstname} {lastname}</span></p>
                            </Link>

                            :
                            <p>Animé par : <span className={"text-primary"}>CWF-COWORKFIT</span></p>
                        }

                        <div className={"flex justify-end p-5"}>
                        <Button className={"text-white"} asChild>
                                <Link href={"/events/" + slug}>
                                    Découvrir
                                </Link>
                            </Button>
                        </div>
                    </div>
                </CardContent>
            </Card>
            <ParticipantModal
                participantOpen={participantOpen}
                participants={participants}
                setParticipantOpen={setParticipantOpen}
            />
        </>
    )
}
